/* eslint-disable */
import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {RootState} from '..';
import {getRegisterStatus, getUser} from '@/helpers/local-storage';

export interface IAuth {
    isAuthenticated?: boolean;
    currentUser?: object;
    isRegisterCompleted?: boolean
}

const initialState = {
    isAuthenticated: !!getUser(),
    currentUser: getUser(),
    isRegisterCompleted: getRegisterStatus()
} as IAuth;

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAuthenticated: (state, action: PayloadAction<boolean>) => {
            state.isAuthenticated = action.payload;
        },
        setCurrentUser: (state, action: PayloadAction<object>) => {
            state.currentUser = action.payload;
        },
        setRegisterComplete: (state, action: PayloadAction<boolean>) => {
            state.isRegisterCompleted = action.payload;
        },
    },
});

export const {setAuthenticated, setCurrentUser, setRegisterComplete} = authSlice.actions;

export const selectIsAuthenticated = (state: RootState): boolean => state.auth.isAuthenticated;
export const selectCurrentUser = (state: RootState): object => state.auth.currentUser;
export const selectIsRegisterCompleted = (state: RootState): boolean => state.auth.isRegisterCompleted;

export default authSlice.reducer;
